<template>
  <v-row justify="center">
    <v-dialog v-model="show" max-width="400px" persistent>
      <v-card>
        <v-card-title style="justify-content: center;">{{modalTitle}}</v-card-title>
        <v-card-text>
          <v-card-text class="pb-0">{{modalIntroSentence}}</v-card-text>
          <v-autocomplete
            v-model="selectedChoice"
            :items="choices"
            :label="listLabel"
            :no-data-text="dataNotFound"
            :item-text="item => item.display"
            item-value="value"
            clearable
            dense
            hide-details
            outlined
            :loading="loading"
            required>
          </v-autocomplete>
          <v-text-field dense v-model="otherChoice" v-if="selectedChoice == 'other'" :placeholder="$t('subOrder.pleaseSpecify')"></v-text-field>
          <slot name="admin-options"></slot>
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-btn
            color="primary"
            tile
            style="width: 50%"     
            :disabled="selectedChoice == undefined || selectedChoice == 'other' && otherChoice.trim() == ''"
            @click="confirm()"
          >{{$t('subOrder.confirm')}}</v-btn>
          <v-btn
            color="secondary"
            class="ml-0"
            style="width: 50%"
            tile
            @click="close()"
          >{{$t('subOrder.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>


<script>
export default {
  name: "SimpleChoiceDialog",
  data() {
    return {
      selectedChoice: undefined,
      otherChoice: undefined
    };
  },
  props: {
    title: {
      type: String,
      default: undefined 
    },
    introductionSentence: {
      type: String,
      default: undefined
    },
    value: {
      type: Boolean,
      default: false
    },
    choices: {
      type: Array,
      required: true,
    },
    choicesListLabel: {
      type: String,
      default: undefined
    },
    noChoiceText: {
      type: String,
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    modalTitle: function(){
      if(!this.title){
        return this.$t("components.modalMultipleChoices.defaultTitle")
      }
      else return this.title
    },
    modalIntroSentence: function(){
      if(!this.introductionSentence){
        return this.$t("components.modalMultipleChoices.defaultText")
      }
      else return this.introductionSentence
    },
    listLabel: function(){
      if(!this.choicesListLabel){
        return this.$t("components.modalMultipleChoices.choices")
      }
      else return this.choicesListLabel
    },
    dataNotFound: function(){
      if(!this.noChoiceText){
        return this.$t("components.modalMultipleChoices.dataNotFoundDefaultText")
      }
      else return this.noChoiceText
    }
  },
  methods: {
    confirm: function() {
      if(this.selectedChoice == "other" && this.otherChoice.trim() != ""){
        this.$emit("confirm", this.otherChoice);
        this.show = false;
      }
      else {
        this.$emit("confirm", this.selectedChoice);
        this.show = false;
      }
    },
    close(){
      this.$emit("close")
      this.show = false;
    },
  }
};
</script>
<style scoped>
.w-45 {
  width: 45%;
}
</style>